/* VF: keep the URL honest when a Convermax vehicle is cleared (Asif, 2026-09-18).

   Convermax carries the selected vehicle in the query string as slash pairs,
   e.g. /collections?Year/2017/Make/Audi/Model/S4 (the homepage platform picker
   links there). Its "Clear" button (.cm_vehicle-widget__discard) and its
   public Convermax.discardVehicle() drop the vehicle from state but never
   touch the URL, so the address bar keeps naming a car that is no longer
   selected and a refresh or a shared link silently re-applies it.

   This strips only the vehicle's own Field/Value pairs from the URL with
   history.replaceState once the vehicle is really gone. Other facets in the
   same query (Category/..., Brand/...) and ordinary ?a=b params are kept.
   replaceState, not pushState: Back should leave the page, not resurrect the
   cleared vehicle. Loaded sitewide because the vehicle widget is in the header.

   Fails safe: if Convermax is missing or still reports a vehicle, the URL is
   left alone. */
(function () {
  'use strict';

  // Used when Convermax can't tell us the vehicle's fields (already cleared)
  var DEFAULT_FIELDS = ['Year', 'Make', 'Model', 'Submodel', 'Engine', 'Trim'];
  var lastFields = null;

  function cm() {
    var c = window.Convermax;
    return c && typeof c.isVehicleSelected === 'function' ? c : null;
  }

  function rememberFields() {
    var c = cm();
    if (!c || typeof c.getVehicle !== 'function') return;
    try {
      var v = c.getVehicle();
      if (v && typeof v === 'object' && Object.keys(v).length) lastFields = Object.keys(v);
    } catch (e) { /* keep the previous list */ }
  }

  // "?Year/2017/Make/Audi/Model/S4/Category/Brakes&page=2" -> "?Category/Brakes&page=2"
  function stripVehicle(search, fields) {
    if (!search || search.length < 2) return search;
    var changed = false;
    var parts = search.slice(1).split('&').map(function (part) {
      // The facet segment is the one with slashes and no key=value shape
      if (part.indexOf('/') === -1 || /^[^/=]+=/.test(part)) return part;
      var tokens = part.split('/');
      var kept = [];
      for (var i = 0; i < tokens.length; i += 2) {
        var field = decodeURIComponent(tokens[i] || '');
        if (i + 1 < tokens.length && fields.indexOf(field) !== -1) { changed = true; continue; }
        kept.push(tokens[i]);
        if (i + 1 < tokens.length) kept.push(tokens[i + 1]);
      }
      return kept.join('/');
    }).filter(function (part) { return part !== ''; });
    if (!changed) return search;
    return parts.length ? '?' + parts.join('&') : '';
  }

  function syncUrl() {
    var c = cm();
    if (!c) return;
    var selected;
    try { selected = c.isVehicleSelected(); } catch (e) { return; }
    if (selected) return;
    var fields = (lastFields || []).concat(DEFAULT_FIELDS);
    var next = stripVehicle(location.search, fields);
    if (next === location.search) return;
    history.replaceState(history.state, '', location.pathname + next + location.hash);
  }

  // Convermax clears asynchronously; check right after the click and once more
  function syncSoon() {
    setTimeout(syncUrl, 0);
    setTimeout(syncUrl, 400);
    setTimeout(syncUrl, 1500);
  }

  // 1. Convermax's own Clear buttons (header widget, collection banner, dialog).
  //    Capture phase so the vehicle's field names are read before it is gone.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('.cm_vehicle-widget__discard, [class*="cm_vehicle-widget__discard"]')) return;
    rememberFields();
    syncSoon();
  }, true);

  // 2. Theme code that calls the public API (the collection banner's Clear link)
  function wrapApi() {
    var c = cm();
    if (!c || typeof c.discardVehicle !== 'function' || c.discardVehicle.__vfUrlSync) return !!c;
    var original = c.discardVehicle;
    var wrapped = function () {
      rememberFields();
      var result = original.apply(this, arguments);
      syncSoon();
      return result;
    };
    wrapped.__vfUrlSync = true;
    try { c.discardVehicle = wrapped; } catch (e) { /* frozen API: the click hook still covers the UI */ }
    return true;
  }

  if (!wrapApi()) {
    var tries = 0;
    var poll = setInterval(function () {
      tries += 1;
      if (wrapApi() || tries > 40) clearInterval(poll);
    }, 250);
  }
})();
